/** @format */

import { Component, Input, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';

import { CHECKOUT_ERROR_MESSAGES } from '@shared/data-access/constants';
import { Chain } from '@shared/data-access/interfaces';

@Component({
  selector: 'common-alert-message',
  templateUrl: './alert-message.component.html',
  styleUrl: './alert-message.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AlertMessageComponent implements OnInit {
  public readonly chain = inject(Chain);

  /**
   * @description
   * The body of the message
   */
  @Input()
  public messageBody: string;

  /**
   * @description
   * The level of the message, e.g. error, warning, info, success, etc.
   */
  @Input()
  public messageLevel: string;

  /**
   * @description
   * The title of the message
   */
  @Input()
  public messageTitle: string;

  /**
   * @description
   * Optional "learn more" link
   */
  @Input()
  public supplementalLink: string;

  /**
   * @description
   * Optional "learn more" link text
   */
  @Input()
  public supplementalLinkText: string;

  @Input()
  public supplementalLinkTargetBlank = true;

  /**
   * @description
   * The name of the icon to display
   */
  public messageIcon: string;

  /**
   * @description
   * The chain abbriviation for brand specific icons.
   */
  public chainIdentifierAbbr = this.chain.chainMarketingIdentifierAbbr;

  /**
   * @description
   * This killswitch is for making the word 'Cart' link back to cart page associated with ticket: BOTF-2253
   */
  @Input()
  public enableErrorMessageCartLink?: boolean;

  ngOnInit(): void {
    // Check to see which icon should be displayed.  NOTE: info level does NOT have an icon, so do not set anything
    if (typeof this.messageLevel === 'string' && this.messageLevel.toLowerCase() === 'error') {
      this.messageIcon = 'exclamation';
    } else if (
      typeof this.messageLevel === 'string' &&
      this.messageLevel.toLowerCase() === 'success'
    ) {
      this.messageIcon = 'check';
    } else if (
      typeof this.messageLevel === 'string' &&
      this.messageLevel.toLowerCase() === 'warn'
    ) {
      this.messageIcon = 'warning';
    } else if (
      typeof this.messageLevel === 'string' &&
      this.messageLevel.toLowerCase() === 'info'
    ) {
      this.messageIcon = 'info';
    } else if (
      typeof this.messageLevel === 'string' &&
      this.messageLevel.toLowerCase() === 'alert-info-filled'
    ) {
      this.messageIcon = 'alert-info-filled';
    } else if (
      typeof this.messageLevel === 'string' &&
      this.messageLevel.toLowerCase() === 'success-warn'
    ) {
      this.messageLevel = 'success';
      this.messageIcon = 'success-warning';
    } else if (
      typeof this.messageLevel === 'string' &&
      this.messageLevel.toLowerCase() === 'alert'
    ) {
      this.messageIcon = 'alert';
    }
    if (this.enableErrorMessageCartLink && this.messageBody) {
      this.cartVerbiageLinkable();
    }
  }

  cartVerbiageLinkable(): void {
    if (
      Object.keys(CHECKOUT_ERROR_MESSAGES).filter((errorMessage) =>
        errorMessage.includes(this.messageBody),
      )
    ) {
      this.messageBody = this.messageBody.replace(
        /Cart/g,
        '<a class="link" href="/OrderItemDisplay" style="text-decoration: underline;">Cart</a>',
      );
    }
  }
}
